import { Blk } from "./useBlock";
import { nf, seoulDate, fileSize } from "./format";

const LANGS = { ko: "한국어", zh: "中文" };
const EMPTY = <div className="empty" style={{ padding: "24px 0" }}>데이터가 없습니다</div>;

// 누를 수 있으면 버튼처럼(키보드 Enter·Space 포함)
const pickProps = (onPick) => (onPick ? {
    role: "button", tabIndex: 0, onClick: onPick,
    onKeyDown: (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onPick(); } },
} : { style: { cursor: "default" } });

function Bar({ label, count, total, color, onPick }) {
    return (
        <div className="bar" {...pickProps(onPick)}>
            <span className="lab">{label}</span>
            <span className="tr"><span className="fl" style={{ width: `${total ? (count / total) * 100 : 0}%`, ...(color ? { background: color } : {}) }}></span></span>
            <span className="n">{nf(count)}건</span>
        </div>
    );
}

export function LangPanel({ langs, onPick }) {
    return (
        <div className="panel" role="region" aria-label="언어별 대화량">
            <div className="pn-h"><h3>언어별 대화량</h3></div>
            <div className="pn">
                <Blk st={langs}>{(d) => {
                    const p = { ko: 0, zh: 0, ...(d?.period || {}) };
                    const total = Object.values(p).reduce((a, b) => a + b, 0);
                    return (
                        <>
                            {Object.entries(p).map(([code, n]) => (
                                <Bar key={code} label={LANGS[code] || code} count={n} total={total}
                                    color={code === "zh" ? "#0f766e" : null} onPick={() => onPick(code)} />
                            ))}
                            <div className="note">중국어 비중 {total ? Math.round((p.zh / total) * 100) : 0}% · 언어는 가맹점주가 앱에서 고른 화면 언어 기준</div>
                        </>
                    );
                }}</Blk>
            </div>
        </div>
    );
}

export function CatPanel({ cats, onPick }) {
    return (
        <div className="panel" role="region" aria-label="분류별 대화량">
            <div className="pn-h"><h3>분류별 대화량</h3></div>
            <div className="pn">
                <Blk st={cats}>{(list) => {
                    if (!list?.length) return EMPTY;
                    const total = list.reduce((a, c) => a + c.count, 0);
                    return list.map((c) => (
                        <Bar key={c.quick_category_id ?? "none"} label={c.name} count={c.count} total={total}
                            onPick={c.quick_category_id === null || c.quick_category_id === undefined ? null : () => onPick(c.quick_category_id)} />
                    ));
                }}</Blk>
            </div>
        </div>
    );
}

export function TopPanel({ top, onPick }) {
    return (
        <div className="panel" role="region" aria-label="인기 질문 TOP 5">
            <div className="pn-h"><h3>인기 질문 TOP 5</h3><span className="hint">같은 질문이 많으면 지식베이스 문서나 공지로 올리세요</span></div>
            <div className="pn" style={{ paddingTop: 6 }}>
                <Blk st={top}>{(list) => (
                    <ul className="lst ul-q">
                        {list?.length ? list.map((q, i) => (
                            <li key={`${i}-${q.question}`} {...pickProps(() => onPick(q.question))}>
                                <span className="rk">{i + 1}</span>
                                <span className="q" style={{ color: "var(--tx)" }}>{q.question}</span>
                                <span className="t">{nf(q.count)}회</span>
                            </li>
                        )) : <li style={{ color: "var(--tx3)", cursor: "default" }}>데이터가 없습니다</li>}
                    </ul>
                )}</Blk>
            </div>
        </div>
    );
}

export function FilesPanel({ files, onKb }) {
    return (
        <div className="panel" role="region" aria-label="최근 등록된 파일">
            <div className="pn-h"><h3>최근 등록된 파일</h3><span className="sp"></span>
                <button type="button" className="btn btn-sm" onClick={onKb}>지식베이스</button></div>
            <Blk st={files}>{(list) => (
                <div className="rep-scroll"><table className="tbl">
                    <thead><tr><th>업로드일</th><th>제목</th><th className="num">크기</th></tr></thead>
                    <tbody>
                        {list?.length ? list.map((f) => (
                            <tr key={f.id}>
                                <td className="c-dt">{f.created_at ? seoulDate(f.created_at) : "–"}</td>
                                <td style={{ whiteSpace: "normal" }}>{f.original_name}</td>
                                <td className="num">{fileSize(f.size)}</td>
                            </tr>
                        )) : <tr><td colSpan={3}><div className="empty">등록된 파일이 없습니다</div></td></tr>}
                    </tbody>
                </table></div>
            )}</Blk>
        </div>
    );
}
